// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import React from 'react';
import {
  DisplayGuatemalanCashBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-guatemalan-cash-brand';
import {cashGuatemalanOutgoingPaymentMapper} from '@tectonics/prs/cash-guatemala';

export const CashGuatemala: PaymentMethod = {
  code: 'cash',
  nameKey: 'volcanes.puntoxpress.name',
  placeOrderMessageKey: 'volcanes.puntoxpress.placeOrder',
  icons: <DisplayGuatemalanCashBrands />,
  outgoingPaymentMapper: cashGuatemalanOutgoingPaymentMapper,
};
